module.exports = __webpack_public_path__ + "static/img/oblique_arrow.50bd81f9.png";